export default "__VITE_ASSET__0d5312b2__"